<script setup>
import Hospital from "./td/Hospital.vue";
import {mdiGestureTap} from "@mdi/js";
import {priorityClass, unitType, ventilated} from "../../utils";
import {convertPriorityToColor, HospitalTypeLabel, StartTriageColorLabel} from "../../choices";
import {pgettext} from "../../../../utils/translate";
import {inject} from "vue";
import {GenderLabel} from "../../../../choices";
import Status from "./td/Status.vue";

const props = defineProps({
    patient: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
    now: {
        type: Object,
        required: true
    },
})

const emit = defineEmits(['displayActionsModal'])

function displayActionsModal() {
    emit('displayActionsModal', props.patient)
}

</script>

<template>
    <tr>
        <td>
            <v-btn class="text-wrap w-auto"
                   variant="tonal"
                   :prepend-icon="mdiGestureTap"
                   @click="displayActionsModal">
                <span class="text-wrap">{{ pgettext('label', 'Options') }}</span>
            </v-btn>
        </td>

        <td class="hpo-tic">
            <strong>{{ patient.temporaryIdentifier }}</strong>
        </td>
        <td class="hpo-tic">
            <strong>{{ patient.tic }}</strong>
        </td>
        <td class="hpo-priority" :class="priorityClass(patient.transportPriority)">
            {{ StartTriageColorLabel[convertPriorityToColor(patient.transportPriority)].toUpperCase() }}
        </td>
        <td>
            <span>{{ GenderLabel[patient.gender] }}</span>
            <span v-if="patient.isChild">
                {{ ' (' }}{{ gettext('child').toUpperCase() }}{{ ')' }}
            </span>
        </td>
        <td class="text-left">{{ patient.lastName }}</td>
        <td class="text-left">{{ patient.firstName }}</td>
        <td>{{ patient.birthDate ? formatShortDate(patient.birthDate) : null }}</td>
        <td class="text-left">{{ patient.diagnose }}</td>
        <td>{{ ventilated(patient.ventilated) }}</td>
    </tr>
</template>

<style scoped>
td {
    padding: 0 2px !important;
    text-align: center !important;
}
</style>